$('input[name="q"]').on("input", function () {
  console.log("new in");
  var q = $(this).val().trim();
  if (q.length > 0) {
    $.ajax({
      url: `/search/suggest?q=${q}&section_id=predictive-search`,
      type: "GET",
      dataType: "html",
      success: function (data) {
        $(".search-result-main").html(data);
        $(".search-result-main").addClass("open");
      },
      error: function (err) {
        console.log("error", err);
      },
    });
  } else {
    console.log("else");
    $(".search-result-main").html("").removeClass("open");
  }
});
